<template>
  <section class="content-list-contents">
    <Breadcrumb :links="links"/>
    <div class="content-list-contents-body">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-3" v-for="n in 8" :key="n">
          <CardListContent/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import CardListContent from './components/CardListContent';

export default {
  data() {
    return {
      links: [
        {
          name: 'Tarefa',
          routerName: 'Tasks'
        },
        {
          name: 'A Procastinação',
          routerName: 'Tasks'
        },
        {
          name: 'Listar Conteúdo',
          routerName: 'ListContents'
        },
      ],
    }
  },
  components: {
    Breadcrumb,
    CardListContent
  }
}
</script>

<style lang="scss" scoped>
.content-list-contents {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
  label {
    width: 100%;
    font-size: 10px;
    font-family: 'Font Light';
    color: var(--black);
    text-align: left;
    padding: 0px 20px;
    margin-bottom: 0;
    span {
      color: var(--red-light);
    }
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px){
    margin-top: 50px;
  }
}
</style>
